$('#consultant-sign-up').submit(function(event){
    $('.danger').text('');

     event.preventDefault();
     var consultantDetail = new FormData($(this)[0]);
     let otpUrl = APP_URL+'/consultant/sign-up'
   
    
     $.ajax({
         url : otpUrl,
         data : consultantDetail,
         dataType : 'json',
         processData: false,
         contentType: false,
         headers: {
                'X-CSRF-Token': csrf 
            },
        type: 'post',  
        beforeSend: function () {
            $("#otp-verification").html('<i class="fa fa-spinner fa-spin"></i>');
        },
        success:(data)=>{
           
              let responseText = data;  
             
            if(responseText.status == 'OTP_SENT')
            {
                $('.otp-div').append(`
                <div class="form-group">
                <input type="text" name="otp" required class="form-control otp" placeholder="Enter OTP sent on mobile" value="">
                <span id="otp-error" class="danger" style="color: red;"></span>
                </div>
                `)
                $("#otp-verification").html('Submit');
                alert('OTP sent to '+responseText.email)
                //alert('OTP : '+responseText.otp)
            }
            if(responseText.msg == 'OTP_verified')
            {
                window.location = APP_URL+'/consultant/detail';
            }
        },  
        error:(reject)=>{
            if( reject.status === 422 ) {
                var validationErrors = JSON.parse(reject.responseText).errors;
              console.log(validationErrors);
                $.each(validationErrors, function (key, val) {
                  
                  console.log(key);
                    $("#" + key + "-error").text(val[0]);
                    console.log($("#" + key + "-error").text(val[0]))
                });
            }
        }
     });

  
    // $.ajax({
    //         url: requestUrl,
    //         data : qualificationDetails,
    //         dataType : 'json',
    //         processData: false,
    //         contentType: false,
    //        // dataType: 'json',
    //         headers: {
    //             'X-CSRF-Token': csrf 
    //         },
    //         type: 'post',
    //         success: function (data) {
    //             // var resp = JSON.parse(data);
    //            // console.log(resp);
    //             swal(data.msg);
    //              getConsultatnQualification();
    //              $('#modal-one').modal('hide');
    //         },
    //         error: function (reject) {
    //             if( reject.status === 422 ) {
    //                 var validationErrors = JSON.parse(reject.responseText).errors;
    //               console.log(validationErrors);
    //                 $.each(validationErrors, function (key, val) {
                      
    //                   console.log(key);
    //                     $("#" + key + "-error").text(val[0]);
    //                     console.log($("#" + key + "-error").text(val[0]))
    //                 });
    //             }
    //         }
    //     });
});